<template>
    <modal id="candiate-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('candidate')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.CANDIDATES'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('first_name')"
                        type="text"
                        v-model="formData.first_name"
                        :placeholder="$placeholder('first_name')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'first_name')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('last_name')"
                        type="text"
                        v-model="formData.last_name"
                        :placeholder="$placeholder('last_name')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'last_name')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('email')"
                        type="email"
                        v-model="formData.email"
                        :placeholder="$placeholder('email')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'email')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('Portfolio')"
                        type="text"
                        v-model="formData.portfolio"
                        :placeholder="$placeholder('portfolio')"
                        :required="false"
                        :error-message="$errorMessage(errors, 'portfolio')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('gender')"
                        type="radio"
                        name="gender"
                        :list="[
                            {id:'male',value: $t('male')},
                            {id:'female', value:  $t('female')},
                            {id:'other', value:  $t('other')}
                        ]"
                        v-model="formData.gender"
                        :error-message="$errorMessage(errors, 'gender')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('status')"
                        list-value-field="translated_name"
                        v-model="formData.status_id"
                        :chooseLabel="$t('status')"
                        :error-message="$errorMessage(errors, 'status_id')"
                        :fetch-url="SELECTABLE_CANDIDATE_STATUS"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('department')"
                        list-value-field="name"
                        v-model="formData.department_id"
                        :chooseLabel="$t('department')"
                        :error-message="$errorMessage(errors, 'department_id')"
                        :fetch-url="SELECTABLE_DEPARTMENT"
                    />
                </div>

                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('job_position')"
                        list-value-field="title"
                        v-model="formData.job_position_id"
                        :chooseLabel="$t('job_position')"
                        :error-message="$errorMessage(errors, 'job_position_id')"
                        :fetch-url="SELECTABLE_JOB_POSITION"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('source')"
                        type="email"
                        v-model="formData.source"
                        :placeholder="$placeholder('source')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'source')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('referral')"
                        list-value-field="full_name"
                        :chooseLabel="$t('Referral')"
                        v-model="formData.referral_id"
                        :required="true"
                        :error-message="$errorMessage(errors, 'referral_id')"
                        :fetch-url="`${apiUrl.TENANT_SELECTABLE_DEPARTMENT_USERS}?without=admin&employee=only&with_auth=yes`"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('date_of_birth')"
                        :placeholder="$placeholder('date_of_birth')"
                        v-model="formData.date_of_birth"
                        :required="true"
                        :error-message="$errorMessage(errors, 'date_of_birth')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('joining_date')"
                        :placeholder="$placeholder('joining_date')"
                        v-model="formData.joining_date"
                        :required="true"
                        :error-message="$errorMessage(errors, 'joining_date')"
                    />
                </div>
            </div>
            <div class="form-group mb-0">
                <label>
                    {{ $t('attachments') }}
                </label>
                <app-input
                    type="dropzone"
                    v-model="attachments"
                    :error-message="errorMessageInArray(errors, 'attachments.0')"
                />
                <small class="text-muted">{{ $t('leave_attachment_allowed_file_types') }}</small>
            </div>
            <br/>
            <br/>
            <!-- ADDRESS -->
            <hr/>
            <h5>{{ $t('candidate') }} {{ $t('address') }} </h5>
            <hr/>
            <div class="row">
                <div class="col-md-12">
                    <app-form-group
                        :label="$t('detail')"
                        :placeholder="$placeholder('detail')"
                        v-model="formData.address_details"
                        :error-message="$errorMessage(errors, 'address_details')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('area')"
                        :placeholder="$placeholder('area')"
                        v-model="formData.area"
                        :error-message="$errorMessage(errors, 'area')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('city')"
                        :placeholder="$placeholder('city')"
                        v-model="formData.city"
                        :error-message="$errorMessage(errors, 'city')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('state')"
                        :placeholder="$placeholder('state')"
                        v-model="formData.state"
                        :error-message="$errorMessage(errors, 'state')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('zip_code')"
                        :placeholder="$placeholder('zip')"
                        v-model="formData.zip"
                        :error-message="$errorMessage(errors, 'zip')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="select"
                        :label="$t('country')"
                        :chooseLabel="$t('country')"
                        v-model="formData.country"
                        :list="countries"
                        form-group-class="mb-md-0"
                        :error-message="$errorMessage(errors, 'country')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="tel-input"
                        :label="$t('phone_number')"
                        :placeholder="$placeholder('phone_number')"
                        v-model="formData.phone_number"
                        form-group-class="mb-0"
                        :error-message="$errorMessage(errors, 'phone_number')"
                    />
                </div>
            </div>

        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {SELECTABLE_DEPARTMENT, SELECTABLE_CANDIDATE_STATUS,SELECTABLE_JOB_POSITION} from "../../../../Config/ApiUrl";

import {
    addChooseInSelectArray,
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import countries from "../../../../Components/View/Employee/Helper/countries";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "CandidateCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {
                gender: 'male',
            },
            SELECTABLE_DEPARTMENT,
            SELECTABLE_CANDIDATE_STATUS,
            SELECTABLE_JOB_POSITION,
            attachments: [],
        }
    },
    computed: {
        countries() {
            return addChooseInSelectArray(countries, 'value', this.$t('country'))
        }
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData = formDataAssigner(new FormData, formData);
            // Remove unwanted fields
            this.attachments.forEach(file => {
                formData.append('attachments[]', file)
            })
            let url = this.apiUrl.CANDIDATES;
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#candidate-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'candidate-table');
                window.location.reload();
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status != 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {

            this.formData = {};
            $('#candidate-modal').modal('hide');
            this.toastAndReload(data.message, 'candidate-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
